import * as React from 'react';
import * as _ from 'lodash';
import { match } from 'react-router';
import { toastr } from 'react-redux-toastr';
import { CasesService } from 'src/share/services/cases';
import { AgenciesService } from 'src/share/services/agencies';
import { IAgency, initialAgency } from 'src/share/types/agency';
import { ICase, initialCase } from 'src/share/types/case/case';
import CaseSidebar from '../CaseSidebar/CaseSidebar';
import Person from './components/Person/Person';
import Information from './components/Information/Information';
import Matches from './components/Matches/Matches';
import Poster from './components/Poster/Poster';
import { Row, Col } from 'reactstrap';
import { AlertsByCase } from 'src/modules/Alert/View/AlertView';
import routes from 'src/modules/Routing/routes';
import { EditCase } from '../Add/Case';
import { IReduxState } from 'src/reduxTypes';
import { connect } from 'react-redux';
import { IAuthState } from 'src/modules/Auth/store/types';
import { bindActionCreators } from 'redux';
import { loginActions } from 'src/modules/Auth/store/actions';
import AgenciesPermissions from '../TransferCase/AgenciesPermission';
import Transfer from '../../Case/TransferCase/Transfer';
import { permissionsCase as getPermissionCase, isAnETLCase } from 'src/share/utils/permissionsCase';
import NotFound from './components/NotFound/NotFound';
import { History } from 'history';

export interface IInformationViewProps {
  match: match<{ caseId: string }>
  history: History;
  location: any;
  auth: IAuthState
  getAgencies: () => Promise<any>
}

export interface IInformationViewState {
  agency: IAgency;
  caseData: ICase;
  loading: boolean;
  isMobile: boolean;
  caseId: string;
  permissionCase: boolean
  isAnETLCase: boolean
  notFound: boolean;
}

export class InformationView extends React.PureComponent<IInformationViewProps, IInformationViewState> {
  constructor(props: IInformationViewProps) {
    super(props);
    this.state = {
      agency: initialAgency,
      caseData: _.cloneDeep({ ...initialCase, children: [] }) as ICase,
      loading: true,
      isMobile: window.innerWidth < 800,
      caseId: props.match.params.caseId,
      permissionCase: false,
      notFound: false,
      isAnETLCase: false
    }
  }
  public componentDidMount() {
    this.loadCaseData();
  }
  public isLoading = (loading: boolean) => {
    return this.setState({ loading })
  }
  public getComponentByPath(path: string) {
    if (this.state.notFound) {
      return <NotFound  {...this.state} {...this.props} />
    }
    const internalRoutes = {
      [routes.EDIT]: <EditCase {...this.state} {...this.props} />,
      [routes.CASEINFO]: <Information {...this.state} {...this.props} />,
      [routes.CASECOMPANIONS]: <Person {...this.state} {...this.props} />,
      [routes.CASECHILDREN]: <Person {...this.state} {...this.props} />,
      [routes.CASEMATCHES]: <Matches {...this.state} {...this.props} />,
      [routes.CASEPOSTER]: <Poster {...this.state} {...this.props} />,
      [routes.TRANSFERCASE]: <AgenciesPermissions {...this.state} {...this.props} {...this.isLoading} loadCaseData={this.loadCaseData} />,
      [routes.TRANSFERCASEADD]: <Transfer {...this.state} {...this.props} {...this.isLoading} loadCaseData={this.loadCaseData} />,
      [routes.ALERTSBYCASE]: <AlertsByCase  {...this.state} {...this.props} />
    }
    return internalRoutes[path];
  }
  public loadCaseData = async () => {
    try {
      const { caseId } = this.props.match.params;
      const caseData = await CasesService.getCaseByID(caseId);
      const agency = await AgenciesService.getByID(caseData.agencyCode);
      const permissionCase = getPermissionCase(caseData.agencyCode, this.props.auth.agencyCode, []);
      this.setState({ caseData, agency: agency as IAgency, permissionCase, isAnETLCase: isAnETLCase(caseData) })
    } catch (error) {
      if (error && error.error === "no data") {
        this.setState({ notFound: true })
      } else {
        toastr.error('Error', 'There was a problem fetching the case information from the server');
      }

    }
    this.setState({ loading: false })
  }
  public render() {
    const { path } = this.props.match;
    const { isMobile } = this.state
    const component = this.getComponentByPath(path);
    return (
      <Row className="container-sidebar">
        <Col className="col-xs-3 col-md-3 col-lg-3 col-xl-2 col-sm-12 col-xs-12 d-none d-xs-none d-md-block no-padding-right case-sidebar-col">
          <CaseSidebar isMobile={false} {...this.props} caseData={this.state.caseData} loading={this.state.loading} />
        </Col>
        <Col className="col-md-9 col-lg-9 col-xl-10 col-sm-12 no-padding-left case-sidebar-col">
          {isMobile ?
            <CaseSidebar
              isMobile={true}
              pageWrapId={'contentCase'}
              {...this.props}
              caseData={this.state.caseData}
              loading={this.state.loading} />
            : null}
          <div id="contentCase">
            {component || null}
          </div>
        </Col>
      </Row>
    )
  }
}
const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});
const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({
    getAgencies: loginActions.getAgencies,
  }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(InformationView);



// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/InformationView.tsx